<template>
  <div>
<!--    <el-dialog :visible.sync="openPayModal" width="300px" :close-on-click-modal="false" :before-close="beforeClose"-->
<!--               :close-on-press-escape="false" style="right: 0;left: auto" :modal="false">-->
      <div style="text-align: center">
        <p style="margin: -20px 10px 10px">恭喜您已经完成测评，请支付{{ '￥' + price }}</p>
        <div class="code-wrap">
          <div>
            <el-image v-show="!paySuccess"
                      style="width: 100px; height: 100%;border-radius: 12px;"
                      :src="pay_code"
                      fit="fill"/>
            <div v-show="paySuccess" style="width: 100px;">
              <el-image
                  style="width: 40px; height: 100%;margin: auto;border-radius: 12px;"
                  :src="paySuccessImg"
                  fit="fill"/>
              <p style="font-size:12px;margin: 10px">支付成功</p>
            </div>
            <p>付款码</p>
          </div>
          <div>
            <el-image
                style="width: 100px; height: 100%;border-radius: 12px;"
                :src="my_code"
                fit="fill"></el-image>
            <p>二维码</p>
          </div>

        </div>
        <p style="margin-top: 10px;background: #eee;padding: 10px;">希望学情解读，请加二维码（语音限免）</p>
        <!--        <div>{{ '￥' + price }}</div>-->
      </div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
      <!--        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>-->
      <!--      </span>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import {getCode, payStatus} from "@/api/api";

export default {
  name: "payModel",
  data() {
    return {
      openPayModal: false,
      pay_code: '',
      my_code: '',
      price: null,
      paySetInterval: null,
      order_no: null,
      paySuccess: false,
      paySuccessImg: require('@/assets/img/success.png')
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    history: {
      type: String,
      default: ''
    }
  },
  methods: {
    beforeClose() {
      // done();
      clearInterval(this.paySetInterval);
    },


    payCode() {
      // if (!this.history && this.type == 3) {
        let that = this
        var FormData = require('form-data');
        var data = new FormData();
        data.append('token', this.$store.state.auth.token);
        getCode(data).then(res => {
          // console.log(res)
          if (res.code == 1) {
            // let obj = {
            //   ...res.data,openPayModal:true
            // }
            // this.$store.commit('OPEN_PAY_MODEL', obj)
            // this.openPayModal = true

            // console.log(res.data,'res.data.')
            that.my_code = res.data.my_code
            that.pay_code = res.data.pay_code
            that.price = res.data.price
            that.$parent.$parent.openPayDiv = true
            that.order_no = res.data.order_no
            setTimeout(() => {
              that.paySetInterval = setInterval(() => {
                that.payStatus().then(res => {
                  // console.log(res,'res')
                  if (res.code == 1) {
                    that.$message.success(res.msg)
                    that.paySuccess = true
                    // that.$store.commit('SET_PAY_SUCCESS',true)
                    clearInterval(that.paySetInterval);
                    // that.$router.push('/home')
                  }
                }).catch(function (err) {
                  console.log(err)
                  if(that.paySuccess) {
                    clearInterval(that.paySetInterval);
                  }
                })
              }, 2000)
            }, 2000);

            // that.drawLine()
          }
        }).catch(function (err) {
          // console.log(err)
          that.$message.error(err.msg)
        })
      // }
    },

    payStatus() {
      return new Promise((res, rej) => {
        payStatus({token: this.$store.state.auth.token, order_no: this.order_no}).then(respore => {
          // console.log(respore)
          if (respore.code == 1) {
            res(respore)
          }
        }).catch(function (err) {
          // console.log(err)
          rej(err)
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.code-wrap {

  > div {
    display: inline-block;
    &:nth-child(1) {
      margin-right: 20px;
    }
    p {
      text-align: center;
    }

  }
}
</style>